import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Usuarios from './pages/usuarios';
import PainelSupervisor from './pages/PainelSupervisor';
import TelaDuplicidades from './pages/TelaDuplicidades';
import MinhasDuplicidades from './pages/MinhasDuplicidades';

function RotaProtegida({ children }) {
  const { usuario, loading } = useAuth();
  if (loading) return null;
  if (!usuario) return <Navigate to="/login" />;
  return children;
}
function RotaAdmin({ children }) {
  const { usuario, loading } = useAuth();
  if (loading) return null;
  if (!usuario) return <Navigate to="/login" />;
  if (usuario.perfil !== 'administrador') return <Navigate to="/dashboard" />;
  return children;
}
function RotaSupervisor({ children }) {
  const { usuario, loading } = useAuth();
  if (loading) return null;
  if (!usuario) return <Navigate to="/login" />;
  if (usuario.perfil !== 'supervisor' && usuario.perfil !== 'administrador') return <Navigate to="/dashboard" />;
  return children;
}
function RotaOperador({ children }) {
  const { usuario, loading } = useAuth();
  if (loading) return null;
  if (!usuario) return <Navigate to="/login" />;
  if (usuario.perfil !== 'operador') return <Navigate to="/equipe" />;
  return children;
}
function RedirecionarInicio() {
  const { usuario, loading } = useAuth();
  if (loading) return null;
  if (!usuario) return <Navigate to="/login" />;
  if (usuario.perfil === 'supervisor' || usuario.perfil === 'administrador') {
    return <Navigate to="/equipe" />;
  }
  return <Navigate to="/dashboard" />;
}
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<RotaProtegida><Dashboard /></RotaProtegida>} />
          <Route path="/equipe" element={<RotaProtegida><PainelSupervisor /></RotaProtegida>} />
          <Route path="/duplicidades" element={<RotaSupervisor><TelaDuplicidades /></RotaSupervisor>} />
          <Route path="/minhas-duplicidades" element={<RotaOperador><MinhasDuplicidades /></RotaOperador>} />
          <Route path="/usuarios" element={<RotaAdmin><Usuarios /></RotaAdmin>} />
          <Route path="/" element={<RedirecionarInicio />} />
          <Route path="*" element={<RedirecionarInicio />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
export default App;
